export const API_BASE_URL = 'https://e2e.apivcm.shop';
//export const API_BASE_URL = 'http://localhost:5002';